import { createTRPCReact, httpBatchLink, loggerLink, splitLink } from "@trpc/react-query";
import { httpSubscriptionLink } from "@trpc/client";
import type { AppRouter } from "@shared/config/trpc";
// import type { AppRouter } from "../../../backend/src/routers";
import superjson from "superjson";

const getBaseURL = () => {
    // In browser, use the current origin
    if (typeof window !== 'undefined') {
        return window.location.origin;
    }
    
    // Fallback for SSR/build time
    return import.meta.env.VITE_TRPC_SERVER_URL || 'http://localhost:8000';
};

export const trpc = createTRPCReact<AppRouter>({
    abortOnUnmount: true,
});

const TRPC_SERVER_URL = getBaseURL();

const TRPC_ENDPOINT_URL = `${TRPC_SERVER_URL}/trpc`;

export const trpcClient = trpc.createClient({
    links: [
        loggerLink({
            enabled: (opts) =>
                (import.meta.env.MODE === "development" && typeof window !== "undefined") ||
                (opts.direction === "down" && opts.result instanceof Error),
        }),
        splitLink({
            condition(op) {
                return op.type === "subscription";
            },
            true: httpSubscriptionLink({
                url: TRPC_ENDPOINT_URL,
                eventSourceOptions() {
                    return {
                        withCredentials: true,
                    };
                },
                transformer: superjson,
            }),
            false: httpBatchLink({
                url: TRPC_ENDPOINT_URL,
                fetch(url, options: any) {
                    return fetch(url, {
                        ...options,
                        credentials: "include",
                    });
                },
                transformer: superjson,
            }),
        }),
    ],
});
